import { AnyAction, IPartialReducer } from "../../core/core-redux/reduxTypes";
import { createReducer } from "../../core/core-redux/reducer/createReducer";
import { SET_WIZARD_PORTAL_URL } from "./setWizardPortalUrl.action";

export interface WizardPortalUrl {
    url?: string;
}

const setWizardPortalUrlPartialReducer: IPartialReducer<WizardPortalUrl> = (
    state: WizardPortalUrl,
    action: AnyAction
) => {
    return {
        url: action.url,
    };
};

export const wizardPortalSettings = createReducer<WizardPortalUrl>(
    {
        url: undefined,
    },
    { [SET_WIZARD_PORTAL_URL]: setWizardPortalUrlPartialReducer }
);
